<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="flex justify-end">
            <vx-tooltip class="position-icon" :text="$t('badges.sendBadge')" position="top" v-if="this.params.data.badgesType == 2">
                <feather-icon icon="SendIcon" class="action-success icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="openSendBadges">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="openUpdateCategory">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteBadge">
                </feather-icon>
            </vx-tooltip>
        </div>
        <vs-popup :title="$t('button.update')" :active.sync="popupActiveUse" class="custom-popup">
            <div class="vx-row items-center">
                <div class="vx-col sm:w-1/2 w-full upload-area">
                    <div class="file-uploads">
                        <div class="mx-auto w-64 h-64 overflow-hidden relative rounded-full cursor-pointer group-image-badges-edit" @click="triggerFileInput">
                        <input ref="fileInput" type="file" id="imageUpload" class="hidden" @change="handleFileChange">
                        <div class="absolute inset-x-0 inset-y-0 object-cover w-full h-full" :style="{ backgroundImage: `url(${imageUrl})`}"></div>
                        <div class="icon-edit-badges flex items-center justify-center w-[50px] h-[50px] rounded-full bg-[#059862] bottom-[10px] absolute left-1/2 transform -translate-x-1/2 text-white z-2">
                            <feather-icon icon="UploadCloudIcon"></feather-icon>
                        </div>
                        </div> 
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="mb-2">
                        <label class="vs-input--label required">{{ $t('badges.title') }}</label>
                        <vs-input class="w-full" v-model="badges.title" type="text" data-vv-validate-on="blur" v-validate="'required'" name="title" />
                        <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                    </div>
                    <div class="mb-2">
                        <label class="vs-input--label required">{{ $t('badges.content') }}</label>
                        <vs-textarea v-model="badges.content" data-vv-validate-on="blur" v-validate="'required'" name="content" :style="{marginBottom:'0px'}"/>
                        <span class="text-danger text-sm">{{ errors.first('content') }}</span>
                    </div>
                    <div class="mb-2">
                        <label class="vs-input--label required">{{ $t('badges.point') }}</label>
                            <vs-input class="w-full" v-model="badges.point" type="number" data-vv-validate-on="blur" v-validate="'required'" name="point" />
                            <span class="text-danger text-sm">{{ errors.first('point') }}</span>
                    </div>
                    <div class="mb-2">
                        <label class="vs-input--label required">{{ $t('badges.timeCount') }}</label>
                        <vs-input class="w-full" v-model="badges.timeCount" type="number" data-vv-validate-on="blur" v-validate="'required'" name="timeCount" />
                        <span class="text-danger text-sm">{{ errors.first('timeCount') }}</span>
                    </div>
                    <div class="mb-2">
                        <label class="vs-input--label">{{ $t('badges.moduleType') }}</label>
                        <v-select class="w-full" v-model="badges.moduleType" :clearable="false" :options="moduleTypeOptions" :reduce="(option) => option.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div> 
                    <div>
                        <label class="vs-input--label">{{ $t('badges.badgesType') }}</label>
                        <v-select class="w-full" v-model="badges.badgesType" :clearable="false" :options="badgesTypeOptions" :reduce="(option) => option.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full mt-5 text-right">
                    <vs-button @click="updateBadges">{{ $t('button.update') }}</vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup :title="$t('badges.sendBadge')" :active.sync="popupSendBages">
            <div class="vx-row items-center">  
                <div ref="selectedOrganizationBranch" class="vx-col w-full mb-2">
                    <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                    <v-select v-model="selectedOrganizationBranch" 
                        :clearable="false" 
                        :options="organizationBranchOptions" 
                        :reduce="(option) => option.value" 
                        @input="onChangeOrganizationBranch" 
                    >
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col w-full mb-2">
                    <label class="vs-input--label">{{ $t('classRoom.classRoom') }}</label>
                    <v-select
                        v-model="selectedClass"
                        :clearable="false"
                        :options="classOptions"
                        :reduce="(option) => option.value"
                        @input="onChangeClassOptions" 
                    >
                        <span slot="no-options">{{ $t('menuOrganization.emptyList') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full mb-2">
                    <label class="vs-input--label">{{ $t('menuOrganization.studentName') }}</label>
                    <v-select
                        v-model="studentId"
                        :clearable="false"
                        :options="studentOptions"
                        :reduce="(option) => option.value"
                    >
                        <span slot="no-options">{{ $t('menuOrganization.emptyList') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full mt-5 text-right">
                    <vs-button @click="sendBadges">{{ $t('badges.sendBadge') }}</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import vSelect from 'vue-select';
export default {
    name:'CellRendererActions',
    components: {
        vSelect
    },
    data() {
        return {
            popupActiveUse:false,
            popupSendBages: false,
            showEdit:false,
            badges: {
              title:null,
              content:null,
              timeCount:null,
              point:null,
              moduleType:1,
              badgesType:1
            },
            moduleTypeOptions:[
              { value: 1, label: 'Trắc nghiệm'},
              { value: 2, label: 'Điểm danh'},
              { value: 3, label: 'Bài tập đánh giá' },
              { value: 4, label: 'Đọc sách' }
            ],
            badgesTypeOptions:[
              { value: 1, label: 'Loại thường'},
              { value: 2, label: 'Loại đc giáo viên tặng'},
            ],
            filesId: [],
            selectedFile: null, 
            imageUrl: '',
            userInfo:JSON.parse(localStorage.getItem('userInfo')),
            organizationBranchOptions:[],
            selectedOrganizationBranch: undefined,
            classOptions:[],
            selectedClass: undefined,
            studentOptions:[],
            studentId: null,

            selectedOrganizationBranchValue: null,
            classID: null
        }
    },
    methods:{
        triggerFileInput() {
            this.$refs.fileInput.click(); 
        },
        handleFileChange(event) {
            this.selectedFile = event.target.files[0];
            if (this.selectedFile) {
                this.imageUrl = URL.createObjectURL(this.selectedFile);
            }
        },
        openUpdateCategory(){
            //console.log('this.params.data', this.params.data)
            this.imageUrl = this.params.data.badgeUrl;
            this.badges.title = this.params.data.title;
            this.badges.content = this.params.data.content;
            this.badges.point = this.params.data.point;
            this.badges.timeCount = this.params.data.timeCount;
            this.badges.moduleType = this.params.data.moduleType;
            this.badges.badgesType = this.params.data.badgesType;
            this.popupActiveUse = true;
        },
        async uploadImage() {
            let formData = new FormData();
            formData.append('files', this.selectedFile);

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };

            try {
                let url = `/school-badges/upload-file`;
                let response = await this.$crm.post(url, formData, config);  
                
                this.badges.fileId = response.data.fileManager.id;
                return true; 
            } catch (error) {
                this.$vs.notify({
                    text: 'Image upload error: ' + (error.response.data.message || 'Đã xảy ra lỗi!'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
                return false; 
            }
        },
        async updateBadges() {
            if (!this.badges.title || !this.badges.content || !this.badges.point || 
                !this.badges.timeCount || !this.badges.moduleType || !this.badges.badgesType) {
                this.$vs.notify({
                    text: this.$t('multipleChoice.notice_field'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                });
                return;
            }

            this.$vs.loading(); 

            try {
                if (this.selectedFile) {
                    const uploadSuccess = await this.uploadImage();
                    if (!uploadSuccess) {
                        this.$vs.loading.close();  
                        return;
                    }
                } else {
                    this.badges.fileId = null;
                }
                await this.$crm.post(`/school-badges/update/${this.params.data.id}`, this.badges);

                this.popupActiveUse = false;
                this.$store.commit('DELETE_CATEGORY', true);

                this.$vs.notify({
                    text: 'Cập nhật huy hiệu thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            } catch (err) {
                this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error || 'Đã xảy ra lỗi!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } finally {
                this.$vs.loading.close(); 
            }
        },
        confirmDeleteBadge(){
            this.$vs.dialog({
                type:'confirm',
                color:'danger',
                title: 'Xác nhận xoá',
                text:`Bạn có chắc là muốn xoá huy hiệu "${this.params.data.title}" không? `,
                accept: this.deleteBadge,
                acceptText:'Xoá',
                cancelText:'Huỷ',
            })
        },
        async deleteBadge() {
            this.$vs.loading(); 
            try {
                await this.$crm.post(`/school-badges/delete/${this.params.data.id}`); 

                this.$store.commit('DELETE_CATEGORY', true); 
                this.$vs.notify({
                    text: 'Xóa huy hiệu thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            } catch (err) {
                this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } finally {
                this.$vs.loading.close();
            }
        },
        getOrganizationBranchOptions(){
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: this.$t('warningMenuOrganization.emptyEmployee'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
        },
        // async getClassOptions(){
        //     return new Promise((resolve, reject) => {
        //         this.$vs.loading();
        //         let schoolStudentSearchDTO = {
        //             organizationBranchId: this.selectedOrganizationBranchValue,
        //             organizationId: this.userInfo.organization.id,
        //             status: true,
        //         }
        //         this.$crm.post('/school-classroom/get-all-class', schoolStudentSearchDTO).then(res => {
        //             this.classOptions = res.data.map(el => {
        //                 return {
        //                     value: el.id,
        //                     label: el.className
        //                 }
        //             })
        //             this.classOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
        //             this.$vs.loading.close();
        //             resolve(res)
        //         }).catch((err) => {
        //             reject(err)
        //             this.$vs.loading.close();
        //             return this.$vs.notify({
        //                 title: 'Có lỗi sảy ra!',
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: 'feather',
        //                 icon: 'icon-alert-circle',
        //                 color: 'danger'
        //             });
        //         });
        //     })
        // },
        async getClassOptions() {
            this.$vs.loading();
            try {
                const schoolStudentSearchDTO = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: this.userInfo.organization.id,
                    status: true,
                };
                const res = await this.$crm.post('/school-classroom/get-all-class', schoolStudentSearchDTO);
                this.classOptions = res.data.map(el => ({
                    value: el.id,
                    label: el.className
                }));
                this.classOptions.unshift({ value: null, label: this.$t('menuOrganization.all') });
            } catch (err) {
                this.$vs.notify({
                    title: 'Có lỗi xảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } finally {
                this.$vs.loading.close();
            }
        },
        async getClassOptions2() {
            this.$vs.loading();
            try {
                const res = await this.$crm.post(`/employee/find-by-id/${this.userInfo.employeeId}`);
                
                if (res.data.managedClassRooms.length > 0) {
                    const branchList = JSON.parse(localStorage.getItem('branchInfoList'));
                    this.classOptions = res.data.managedClassRooms.map(el => {
                        const branch = branchList.find(x => x.id === el.organizationBranchId);
                        if (branch) el.organizationBranchName = branch.organizationBranchName;
                        return {
                            value: el.id,
                            label: `${el.className} - ${el.organizationBranchName}`
                        };
                    });
                } else {
                    this.classOptions = [];
                }
                
                return res;
            } catch (err) {
                this.$vs.notify({
                    title: 'Có lỗi xảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
                throw err;
            } finally {
                this.$vs.loading.close();
            }
        },
        async openSendBadges(){
            //console.log('this.userInfo', this.userInfo)
            const permissions = this.userInfo.userRole
            //console.log('permissions:', permissions);

            this.organizationBranchOptions = []
            this.classOptions = []

            //organization user
            if(permissions == 'organization'){
                this.getOrganizationBranchOptions()
                await this.getClassOptions()
            }
            else{
                this.$refs.selectedOrganizationBranch.style.display = "none"
                await this.getClassOptions2()
            }
            this.selectedOrganizationBranch = null
            this.selectedClass = null

            this.popupSendBages = true;
        },
        onChangeOrganizationBranch(){
            this.studentOptions = [{value: null, label:"Tất cả"}]
            this.selectedClass = null
            this.studentOptions = []
            this.selectedOrganizationBranchValue = this.organizationBranchOptions.find(option => option.value === this.selectedOrganizationBranch).value;
            this.getClassOptions()
        },
        async getStudentOptions(classID) {
            this.$vs.loading();

            const schoolStudentSearchDTO = {
                organizationId: this.userInfo.organization.id,
                sort: 'id',
                classId: classID || this.classID,
                enabled: true,
                pageNumber: 1,
                pageSize: 1000,
            };

            try {
                const response = await this.$crm.post('/school-student/find-by-condition', schoolStudentSearchDTO);
                this.studentOptions = response.data.content.map(item => ({
                    value: item.id,
                    label: item.fullName
                }));
            } catch (err) {
                this.$vs.notify({
                    title: 'Có lỗi xảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
                throw err;
            } finally {
                this.$vs.loading.close();
            }
        },
        async onChangeClassOptions(){
            this.classID = this.classOptions.find(option => option.value === this.selectedClass).value;
            this.studentOptions = []
            this.studentId = null
            await this.getStudentOptions(this.classID)
        },
        sendBadges(){
            //console.log('this.classID', this.classID);
            //console.log('this.params.data.id', this.studentId);
            this.$vs.loading();
            this.$crm.post(`/school-badges/send-badges/${this.params.data.id}/${this.studentId}`)
                .then(() => {
                    this.popupSendBages = false;
                    this.$vs.notify({
                        text: 'Gửi huy hiệu thành công',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'
                    });
                })
                .catch((err) => {
                    this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
        mounted() {
            this.$eventBus.$on('', () => {
                this.$store.commit('DELETE_CATEGORY', true)
            })
        }
    }
}
</script>
<style scoped>
.required::after {
  content: '* ';
  color: red;
}
.custom-popup >>> .vs-popup{
  width: 60vw; 
  max-width: 1200px; 
}
.upload-area .file-upload {
  width: 150px;
  height: 150px;
  border: dashed 2px rgba(var(--vs-primary), 1);
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-area .button-upload button {
  border-radius: 1.5rem;
}
.upload-area .file-label {
  color: #C0C0C0;
}
.table-files .vs-table--tbody,
.table-files .vs-table--thead {
  position: static;
}
.table-files  .vs-pagination--buttons {
  z-index: 0;
}
.icon-edit-badges {
    width: 50px;
    height: 50px;
    background-color: #059862;
    bottom: 10px;
    left: 50%;
    opacity:1;
    visibility: visible;
    transition: all .1s ease-in-out;
}
.group-image-badges-edit:hover img{
    filter: grayscale(0.2);
}
</style>
